import { useEffect, useState } from "react";

// STYLES
import * as Style from "./AuthenticateStyle";

// LIBRARIES
import { useNavigate } from "react-router-dom";

// MISC
import SupIcon from "assets/LoginAssets/LOGO.svg";
import { ButtonTypes, InputTypes } from "models/GeneralTypes/generalTypes";
import { IAuthentificationPayload } from "models/interfaces";

//ASSETS

// REDUX
import { authenticate } from "api/sessionApi";
import { useAppDispatch } from "hooks/reduxHooks";
import { resetStore } from "store/store";

// COMPONENTS
import { getUser } from "api/sessionApi";
import ButtonAtom from "components/Atoms/ButtonAtom/ButtonAtom";
import InputAtom from "components/Atoms/InputAtom/InputAtom";

const Authenticate = () => {
  // PROPS

  // CONSTANTS USING LIBRARIES
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  // CONSTANTS USING HOOKS
  const [password, setPassword] = useState<string>("");
  const [username, setUsername] = useState<string>("");

  // GENERAL CONSTANTS

  // USE EFFECT FUNCTION
  useEffect(() => {
    dispatch(resetStore());
    //eslint-disable-next-line
  }, []);

  // REQUEST API FUNCTIONS
  const handleLogin = () => {
    let loginPayload: IAuthentificationPayload = {
      password: password,
      username: username,
    };
    dispatch(authenticate(loginPayload))
      .unwrap()
      .then(() => {
        // Store username in localStorage
        localStorage.setItem('username', username);

        const getUserPayload = {
          phoneNumber: username,
        };
        dispatch(getUser(getUserPayload))
          .unwrap()
          .then((response) => {
            console.log("get user response:", response);
            navigate("/dashboard");
          });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <Style.AuthenticateContainer>
      <Style.FormWrapper>
        <Style.SupIconImage src={SupIcon} />
        <Style.ContentContainer>
          <Style.CenteredElementsContainer>

            <Style.InputContainer>
              <Style.WelcomeTitle>Login</Style.WelcomeTitle>
              <InputAtom
                name="username"
                inputValue={username}
                setInputValue={setUsername}
                type={InputTypes.LOGIN_INPUT}
                placeholder="Email"
              />
            </Style.InputContainer>
            <Style.InputContainer>
              <InputAtom
                name="password"
                inputValue={password}
                setInputValue={setPassword}
                type={InputTypes.PASSWORD_INPUT}
                placeholder="Parola"
              />
              <Style.ForgotPassword>
                Forgot Password?
              </Style.ForgotPassword>
            </Style.InputContainer>

          </Style.CenteredElementsContainer>
          <Style.ButtonContainer>
            <ButtonAtom
              text="Login"
              onClick={handleLogin}
              type={ButtonTypes.MAIN_BUTTON}
            />
          </Style.ButtonContainer>
        </Style.ContentContainer>
      </Style.FormWrapper>
    </Style.AuthenticateContainer>
  );
};

export default Authenticate;
